import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-[#4FA3D1]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Bug bundle #12 (2026-08-19) — full_access bypass. Matches backend
  // `_require_role` and `assert_permission` overrides so users granted
  // Full Access can visit any allowedRoles-gated route.
  if (allowedRoles && !allowedRoles.includes(user.role) && user.full_access !== true) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
